/*
Author : Abaid
Module: Visitor Types
github: https://github.com/abaid
*/
import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';

const VisitorTypesSlice = createSlice({
    name: 'visitorTypes',
    initialState: {
        createVisitorTypes: {},
        updateVisitorTypes: {},
        getVisitorTypeById: null
    },
    reducers: {
    },
    extraReducers: {
        'visitorTypes/createVisitorTypes/fulfilled': (state, action) => {
            state.createVisitorTypes = ResponseApi(action.payload);
        },
        'visitorTypes/updateVisitorTypes/fulfilled': (state, action) => {
            state.updateVisitorTypes = ResponseApi(action.payload);
        },
        'visitorTypes/getVisitorTypeById/fulfilled': (state, action) => {
            state.getVisitorTypeById = ResponseApi(action.payload);
        }
    },
});

export const {} = VisitorTypesSlice.actions;

export default VisitorTypesSlice.reducer;
